import Header from '../../../Components/Header/Header';
import styles from './service-detail.module.scss';
import { Helmet } from 'react-helmet-async';
import useInView from '../../../Components/UseInView/useInView';
import Cta from '../../../Components/Cta/Cta';
import Footer from '../../../Components/Footer/Footer';
import RevealImage from '../../../Components/RevealImage/revealImage';
import serviceList from '../../../Data/Services.json';
import { useParams } from 'react-router-dom';

const ServiceDetail = () => {
    const { id } = useParams();
    const [serviceRef, serviceVisible] = useInView();

    const service = serviceList.find((s) => String(s.id) === String(id));

    return (
        <>
            <Helmet>
                <title>Clear Property Management - Property Management Services</title>
                <meta name='description' content='We provide property management services.' />
                <link rel='canonical' href='/' />
            </Helmet>
            <Header />

            <p>[Services]</p>
            <h1>{service.title}</h1>

            <div
                id='Service Landing'
                ref={serviceRef}
                className={`${styles.serviceWrapper} ${serviceVisible ? styles.visible : ''}`}
            >
                <div className={styles.serviceLeft}>
                    <h2>Service Overview</h2>
                    <p>{service.fullDescription}</p>
                </div>
                <div className={styles.serviceLeft}>
                    <RevealImage
                        src={service.image}
                        alt='landing'
                        imageStyle={{
                            width: '100%',
                            height: '400px',
                            objectFit: 'cover',
                        }}
                        rollUpColor='#f6f6f6'
                    />
                </div>
            </div>

            <div id='Cta' className={`${styles.sectionContainer} ${styles.visible}`}>
                <Cta />
            </div>

            <Footer />
        </>
    );
};

export default ServiceDetail;
